var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-component",attrs:{"id":_vm.faq.order}},[_c('div',{staticClass:"question-container"},[_c('h5',[_vm._v(_vm._s(_vm._f("translateToCurrentLang")(_vm.$language.current,_vm.faq.questionEs, _vm.faq.questionEn)))])]),_c('div',{staticClass:"paragraph-container"},[_c('span',{domProps:{"innerHTML":_vm._s(
        _vm.content
      )}})])])}
var staticRenderFns = []

export { render, staticRenderFns }